export const getAdminCompanyId = () => {
  // eslint-disable-next-line n/prefer-global/process
  if (process.env.NODE_ENV === 'mock') return 112;

  const element = document.querySelector<HTMLInputElement>('#company-id');
  if (!element) throw new Error('Not exist company-id input');

  const id = Number.parseInt(element.value, 10);
  if (Number.isNaN(id)) throw new Error('Invalid variable company-id');
  return id;
};
